<div class="faq">
    <div class="row">
        <div class="col-xs-12 offset-xs-0 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 faq__body">
            <p class="faq__body__title">{{title}}</p>
            <a (click)="isModalOpen = true; emitEvent();" class="faq__body__link" id="faqSubtituloButton">{{subtitle}}</a>
        </div>
    </div>
</div>
<dss-drawer class="modal-faq" [open]="isModalOpen" (closeDrawer)="isModalOpen = false; eventEmitClick($event); closeAccordion();">
    <dss-drawer-header>{{modalTitle}}</dss-drawer-header>
    <dss-drawer-body>
        <div class="faq-panel">
            <dss-accordion #accordion>
                <dss-accordion-item *ngFor="let faq of faqItems">
                    <h1 dssAccordionItemTitle>{{faq.question}}</h1>
                    <ng-container dssAccordionItemBody>
                        <p [innerHtml]="faq.answer"></p>
                    </ng-container>
                </dss-accordion-item>
            </dss-accordion>
        </div>
    </dss-drawer-body>
    <dss-drawer-footer>
        <button dssFilledButton (click)="isModalOpen = false; eventEmitClick($event); closeAccordion();" id="fecharButton">{{closeText}}</button>
    </dss-drawer-footer>
</dss-drawer>
